<template>
	<div class="homePage">
		<div class="bid-list bid-list__list layout shadow">
<div class="bid-list__header">
  <h2 class="h2 bid-list__h2">招标公告</h2>
  
</div>

<div class="bid-list__content bg-white">

  <ul class="bid-list__content-header bid-list__item bidList__item clearfix bg-fafafa tab_bidtype">
  <li><div>招标类别</div></li>
  <li><div>项目名称</div></li>

  <li><div><span class="desc-state">公告日期</span></div></li>

  </ul>
  
   <div class="bid-list__content-content">
      <ul class="bid-list__content-ul bid-list__item bidList__item clearfix " v-for="(item) in tableData" :key="item.article_id">
      <li><div><p><a  @click.stop="goto(item.article_id)" >{{item.category.name}}</a></p></div></li>
      <li><div><p><a  @click.stop="goto(item.article_id)">{{item.title}}</a></p></div></li>
      <li><div><p>{{item.bdate}}</p></div></li>
      <li ><div><p><a class="bid-list__button" @click.stop="goto(item.article_id)"> 查看 </a></p></div></li>
      </ul>
       
      
       
   </div>


</div>



</div>
<el-pagination :pager-count="5" class="pagination" background layout="pager" 
   :total="total" :current-page="page" :page-size="page_size" @current-change="setPage"></el-pagination>
			
	</div>
</template>

<script>
	export default {
		name: "homePage",
		components: {},
		data() {
			return {
				tableData: [],
				page:1,//当前页
				page_size:15,
				total:0,//全部条数
			};
		},
		created() {
			
		},
		mounted() {
			this.getreqZhaobiaoList()
		},
		methods: {
			setPage(e){
				this.page = e;
				this.getreqZhaobiaoList();
			},
			
			async getreqZhaobiaoList(){
				let that = this
				let res = await this.req.reqZhaobiaoList({
					page:this.page,
				});
				console.log(res)
				
				if (res.status == 200) {
					this.tableData = res.data.list.data;
					this.total = res.data.list.total;
					this.page = res.data.list.current_page;
					this.page_size = res.data.list.per_page;
				} else {
					this.$message.error(res.message);
					
				}
			},

			goto(rows){
				this.$router.push({ name: 'detail', query: { id: rows }})	
			},

			
		},
	};
</script>

<style lang="less" scoped>
	.pagination{
				margin: 40px auto 0px;
				display: flex;
				align-items: center;
				justify-content: center;
			}
	
</style>
